const STORAGE = '/storage';

export const WIFI_TUTORIAL_PATH = STORAGE + '/tutorial-wi-fi.pdf';
export const LTE_TUTORIAL_PATH = STORAGE + '/tutorial-lte.pdf';
export const TEMPLATE_SCRIPT_PATH = STORAGE + '/template/index.js';
export const TEMPLATE_STYLE_PATH = STORAGE + '/template/style.css';
